$our_app $mol_book2_catalog
	menu_title \Нашы Игры
	param \page
	menu_foot /
		<= GitHub $mol_link_source uri \https://github.com/Lyumih/our
		<= Telegram $mol_link
			sub / <= Telegram_icon $mol_icon_telegram
			uri \https://t.me/h_y_o_o/4484
	spreads *
		- auth <= Auth $mol_page
		- Шоу, которые предстоят и текущий статус к ним
		show <= Show $mol_page
			title \Шоу
			body / <= Show_text $mol_text text \
				\Список шоу, которые проходят и будут проходить в ближайшее время
				\- Нашы игры 2024
				\(список игр и их статус)
				\- Нашы игры 2023
				\- [Василиса и Баба Яга](https://store.steampowered.com/app/2331070/_/). Нашы игры 2023. Финал
				\- [SKIBIDI: ESCAPE FROM TOILETS!](https://store.steampowered.com/app/2497560/SKIBIDI_ESCAPE_FROM_TOILETS/). Нашы игры 2023. 2 поток
		- Список игр, которые доступны в шоу
		games <= Games $mol_page
			title \Игры
			body / <= Game_text $mol_text text \
				\Список игр, которые будут участвовать в шоу
				\- [Василиса и Баба Яга](https://store.steampowered.com/app/2331070/_/). Нашы игры 2023
				\- [Василиса и Кот учёный](https://store.steampowered.com/app/2331070/_/).
		- Профиль разработчика для добавления игр в шоу
		dev <= Dev $our_app_dev
		- Профиль организаторов. Список игр, статус шоу, обратная связь
		org <= Org $our_app_org
		about <= About $mol_page
			title \Наши
			body /
				<= About_text $mol_text text \
					\# Наши
					\Наши - это платформа для проведения игровых шоу, которая помогает соединить зрителей, разработчиков и организаторов игр.
					\**Зритель** - может посмотреть ближайшие игровые шоу, которые будут проходить и игры, которые будут в них принимать участия
					\**Разработчик** - может зарегистрироваться и подать заявку на участие в шоу со своей игрой и получить обратную связь
					\**Организация** - может в удобной форме обработать заявки и дать обратную связь по игре для шоу
